"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobMapper = void 0;
const mappers_1 = require("./ai-classification/mappers");
const mappers_2 = require("./catalog-export/mappers");
const mappers_3 = require("./catalog-import/mappers");
class JobMapper {
    toJob(jobResource) {
        switch (jobResource.attributes.kind) {
            case 'AiClassification':
                return mappers_1.toCanonicalAiClassificationJob(jobResource);
            case 'CatalogExport':
                return mappers_2.toCanonicalCatalogExportJob(jobResource);
            case 'CatalogImport':
                return mappers_3.toCanonicalCatalogImportJob(jobResource);
        }
    }
    toJobResource(job) {
        switch (job.kind) {
            case 'AiClassification':
                return mappers_1.toJsonapiAiClassificationJob(job);
            case 'CatalogExport':
                return mappers_2.toJsonapiCatalogExportJob(job);
            case 'CatalogImport':
                return mappers_3.toJsonapiCatalogImportJob(job);
        }
    }
    toJobCreation(jobCreationResource) {
        switch (jobCreationResource.attributes.kind) {
            case 'AiClassification':
                return mappers_1.toCanonicalAiClassificationJobCreation(jobCreationResource);
            case 'CatalogExport':
                return mappers_2.toCanonicalCatalogExportJobCreation(jobCreationResource);
        }
    }
    toJobCreationResource(jobCreation) {
        switch (jobCreation.kind) {
            case 'AiClassification':
                return mappers_1.toJsonapiAiClassificationJobCreation(jobCreation);
            case 'CatalogExport':
                return mappers_2.toJsonapiCatalogExportJobCreation(jobCreation);
        }
    }
}
exports.JobMapper = JobMapper;
//# sourceMappingURL=jsonapi-job-mapper.js.map